/**
 * Module-level singleton instances for the Relay environment and app service.
 * These are exported so that entrypoints can access the environment for preloading queries.
 */
import { createBrowserEnvironment } from "../relayenv";
import { createAppService } from "../app-controller/AppService";
import { iOS } from "../app/DeviceInfo";
import type { DeviceInfo } from "../app/DeviceInfo";

// Create these once at module level to avoid recreating on each render
export const deviceInfo: DeviceInfo = {
  isIOS: iOS(),
};

export const appService = createAppService();
export const environment = createBrowserEnvironment(appService);
